import { render, staticRenderFns } from "./DebtorInfo.vue?vue&type=template&id=74c2c762&scoped=true&"
import script from "./DebtorInfo.vue?vue&type=script&lang=js&"
export * from "./DebtorInfo.vue?vue&type=script&lang=js&"
import style0 from "./DebtorInfo.vue?vue&type=style&index=0&id=74c2c762&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c2c762",
  null
  
)

export default component.exports